import { createNamespacedHelpers } from 'vuex';
const { mapState } = createNamespacedHelpers('integrations');

export const form = {
	computed: {
		...mapState(['activeContent', 'addingIntegration', 'editingIntegration']),
		integration() {
			return this.editingIntegration ? this.$get('activeContent.integration', {}) : {};
		},
		/**
		 * The ID
		 *
		 * @since 2.4.0
		 *
		 * @returns {int} The active integration id.
		 */
		id() {
			return this.$get('integration.id', '');
		},
		/**
		 * Button Title
		 *
		 * @since 2.4.0
		 *
		 * @returns {string} The button title.
		 */
		buttonTitle() {
			return this.addingIntegration
				? `Connect ${this.$get('provider.name', '')} Integration`
				: 'Update Integration';
		},
		/**
		 * Whether this provider is monsterleads-existing.
		 *
		 * @since 2.4.0
		 *
		 * @returns {boolean} Whether this provider is monsterleads-existing.
		 */
		isMonsterLeads() {
			return 'monsterleads-existing' === this.provider.slug;
		},

		/**
		 * Is Oauth?
		 *
		 * @since 2.4.0
		 *
		 * @returns  {boolean} Does this provider require Oauth?
		 */
		isOauth() {
			return false !== this.$get('provider.supports.oauth', false);
		},
		/**
		 * Is Legacy?
		 *
		 * @since 2.4.0
		 *
		 * @returns  {boolean} Is this provider Legacy?
		 */
		isLegacy() {
			return this.$get('provider.legacy', false);
		},
		/**
		 * Is Pardot?
		 *
		 * @since 2.4.0
		 *
		 * @returns  {boolean} Is this provider Pardot?
		 */
		isPardot() {
			return 'salesforce-pardot' === this.provider.slug.substr(0, 'salesforce-pardot'.length);
		},
		/**
		 * Is monsterleads?
		 *
		 * @since 2.4.0
		 *
		 * @returns  {boolean} Is this provider monsterleads?
		 */
		isMonsterleads() {
			return 'monsterleads' === this.provider.slug.substr(0, 'monsterleads'.length);
		},
		/**
		 * Is getresponse?
		 *
		 * @since 2.4.0
		 *
		 * @returns  {boolean} Is this provider getresponse?
		 */
		isGetresponse() {
			return 'getresponse' === this.provider.slug.substr(0, 'getresponse'.length);
		},
		/**
		 * Can create new.
		 *
		 * @since 2.4.0
		 *
		 * @returns {void}
		 */
		canCreate() {
			return 'monsterleads-existing' !== this.provider.slug && !this.isLegacy;
		},
		/**
		 * Can update integration.
		 *
		 * @since 2.4.0
		 *
		 * @returns {void}
		 */
		canUpdate() {
			return !this.isLegacy;
		},
	},
	methods: {
		fallbackName() {
			let fallback = `${this.provider.name} Integration`;
			if (this.$appData('blogname')) {
				fallback += ` [${this.$appData('blogname')}]`;
			}
			return fallback;
		},
		/**
		 * Field Type
		 *
		 * @since 2.4.0
		 *
		 * @param {Object} field The field object.
		 *
		 * @returns {string} The field type.
		 */
		getFieldsSetup() {
			const fields = {
				name: this.$get('$store.state.integrations.editingIntegration')
					? this.$get('$store.state.integrations.activeContent.integration.label', this.fallbackName())
					: this.fallbackName(),
			};

			const supportFields = this.$get('provider.supports.fields', []) || [];
			supportFields.forEach((field) => {
				fields[field.id] = '';
			});

			return {
				supportFields,
				visibleFields: supportFields.filter((f) => !!f.label),
				hiddenFields: supportFields.filter((f) => !f.label),
				fields,
				defaultIntegration: this.$get('$store.state.integrations.addingIntegration'),
			};
		},
	},
};
